const API = process.env.REACT_APP_BACKEND_URL;
export const NC = `${API}/api/nutri-cheques`;

export const fmtEur = (v) => `${(v ?? 0).toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€`;

export const STATUS_ORDER = ['pedido_recebido', 'registado_validado', 'consulta_realizada', 'fatura_emitida', 'reembolso_recebido', 'filipa_paga'];

export const STATUS_LABEL = {
  pedido_recebido: 'Pedido recebido',
  registado_validado: 'Registado e validado',
  consulta_realizada: 'Consulta realizada',
  fatura_emitida: 'Fatura emitida',
  reembolso_recebido: 'Reembolso recebido',
  filipa_paga: 'Nutricionista paga',
};

export const STATUS_CLS = {
  pedido_recebido: 'bg-brand-bg text-brand-muted border-brand-border',
  registado_validado: 'bg-blue-50 text-blue-700 border-blue-200',
  consulta_realizada: 'bg-violet-50 text-violet-700 border-violet-200',
  fatura_emitida: 'bg-amber-50 text-amber-700 border-amber-200',
  reembolso_recebido: 'bg-brand-green/10 text-brand-green border-brand-green/30',
  filipa_paga: 'bg-emerald-100 text-emerald-800 border-emerald-300',
};

export function orderFor(cheque) {
  return cheque?.requires_split ? STATUS_ORDER : STATUS_ORDER.slice(0, -1);
}

export default NC;
